// src/routes/resetPasswordRoute.jsx
import ResetPassword from '../pages/Auth/ResetPassword';

export const resetPasswordRoute = {
  path: '/reset-password',
  element: <ResetPassword />
};